module.exports = "<div class=\"row auth__wrapper\">\n  <div class=\"col\">\n    <ui-view></ui-view>\n  </div>\n</div>\n"